'use client';

import React from 'react';
import { Flex, Heading, Text, VStack, HStack } from '@shared/ui';
import { useSectionContext } from './useSectionContext';
import { SectionButtons } from './SectionButtons';

type SectionHeadProps = {
    title: string;
    description?: string;
    hint?: React.JSX.Element | string;
};

export const SectionHead: React.FC<SectionHeadProps> = (props) => {
    const { title, description, hint } = props;

    const {
        state: { usePositiveButton },
    } = useSectionContext();

    return (
        <HStack justifyContent="space-between">
            <VStack
                mb={{
                    base: 's',
                    md: 'xl',
                    lg: '18px',
                }}
                spacing={{
                    base: 'xxs',
                    md: 'xs',
                }}
                alignItems="start"
            >
                <Flex columnGap="xs" alignItems="center">
                    <Heading
                        as="h1"
                        fontSize={{
                            base: 'sm',
                            md: 'md',
                        }}
                        fontWeight="bold"
                    >
                        {title}
                    </Heading>
                    {hint}
                </Flex>
                <Text
                    color="neutral.080"
                    fontSize={{
                        base: 'least',
                        md: 'xs',
                        lg: 'least',
                    }}
                >
                    {description}
                </Text>
            </VStack>
            {usePositiveButton && <SectionButtons />}
        </HStack>
    );
};

export type SectionHeadReturn = ReturnType<typeof SectionHead>;
